module.exports = __webpack_public_path__ + "static/03-7c9f2c76b20e805d186c11eb89cad827.jpg";